import { api } from './client';

export interface MecaMonth {
  key: string;
  label: string;
  year: number;
  future: boolean;
  meetings: number;
  clients: number;
  conversionPct: number | null;
  avgSale: number | null;
  revenue: number;
}

export interface MecaReport {
  fy: number;
  quarter: number;
  months: MecaMonth[];
  average: { meetings: number | null; clients: number | null; conversionPct: number | null; avgSale: number | null; revenue: number | null };
}

/** fy = starting year of the financial year (2026 = Apr 2026 – Mar 2027); quarter 1 = Apr–Jun. Omit both for the current quarter. */
export async function getMecaReport(fy?: number, quarter?: number): Promise<MecaReport> {
  const r = await api.get<MecaReport>('/reports/meca', { params: { fy, quarter } });
  return r.data;
}
